import { render } from "./ArtistDetails.vue?vue&type=template&id=dac28a5c"
import script from "./ArtistDetails.vue?vue&type=script&lang=js"
export * from "./ArtistDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__